import React, {Component} from 'react';
import {Form, DatePicker, TimePicker} from 'antd';
import moment from 'moment';
import {formatDate} from "../../../../utils";

const range = (start, end) => {
    const result = [];
    for (let i = start; i <= end; i++) {
        result.push(i);
    }
    return result;
}

// const disableNowTime = date => {
//     if(date.year() === moment().year()
//         && date.month() === moment().month()
//         && date.date() === moment().date()
//     ){
//         if(date.hour() === moment().hour()){
//             return {
//                 disabledHours: ()=>range(0, moment().hour()),
//                 disabledMinutes: ()=>range(0, moment().minute()),
//             };
//         }else if(date.hour() >= moment().hour()){
//             return {
//                 disabledHours: ()=>range(0, moment().hour()),
//             };
//         }return {
//             disabledHours: ()=>range(0, 25),
//             disabledMinutes: ()=>range(0, 61),
//         };
//     }
// };
const disableNowTime = (date) => {
    let currentDay = moment().date();
    let currentHours = moment().hours();
    let currentMinutes = moment().minutes();
    let settingHours = moment(date).hours();
    let settingDay = moment(date).date();
    if (date && settingDay === currentDay && settingHours === currentHours) {
        return {
            disabledHours: () => range(0, currentHours-1),         //设置为当天这一小时，禁用该小时，该分钟之前的时间
            disabledMinutes: () =>range(0, currentMinutes-1),
        };
    }else if (date && settingDay === currentDay && settingHours > currentHours) {
        return {
            disabledHours: () => range(0, currentHours-1),      //设置为当天这小时之后，只禁用当天该小时之前的时间
        };
    }else if (date && settingDay === currentDay && settingHours < currentHours) {
        return {
            disabledHours: () => range(0, currentHours-1),      //若先设置了的小时小于当前的，再设置日期为当天，需要禁止选中
            disabledMinutes: () =>range(0, 59),
        }
    }else if (date && settingDay > currentDay) {
        return {
            disabledHours: () => [],                     //设置为当天之后的日期
            disabledMinutes: () => [],
        }
    }
};

class NormalDateInput extends Component {

    render() {
        return (
            <Form.Item label={this.props.label} required={this.props.empty} style={{display:"flex"}}>
                <DatePicker placeholder={this.props.placeholder?this.props.placeholder:"请选择"}
                            showTime={{format: 'HH:mm'}}
                            format={this.props.format || "YYYY-MM-DD HH:mm"}
                            className={"normalInput"}
                            value={this.props.itemValue ? moment(this.props.itemValue) : undefined}
                            disabledDate={currentDate=>{
                                return currentDate < moment().add(-1, "day");
                            }}
                            disabledTime={disableNowTime}
                            style={{width:"266px"}}
                            onChange={(current,dateString)=>{
                                // this.props.callBack && this.props.callBack(dateString ? new Date(dateString).getTime() : undefined);
                                this.props.callBack && this.props.callBack(dateString ? current.valueOf() : null);
                            }}/>
                <style>{`.normalInput .ant-calendar-picker-input{background: rgba(0, 80, 179, 0.04);border: "1px solid rgba(0, 80, 179, 0.08)}`}</style>
            </Form.Item>
        );
    }
}

export default NormalDateInput;
